function createBreadcrumb(loc,childTitle){
    var currLoc = $(location).attr('href');
     if(loc == 0){
        $("#navigation").html("");
        var breadLink0 = "<li class='flex items-center'><a class='breadcrumbs-list__link' href='{{ routes.root_url }}'>{{ home_title | escape }}</a></li>";
        $("#navigation").append(breadLink0);
        var breadLink2 = "<li class='flex items-center collection-link link-end'>{{ collection.title }}</li>";
        $("#navigation").append(breadLink2);

    }
    if(loc == 1){
      $(".link_child").each(function(){
      var linkURL = $(this).attr("href");
      if(currLoc.indexOf(linkURL) > -1){
        var crnt_title = $(this).parents(':eq(5)').find(".main-nav__item").attr("crnt_title");
        var crnt_link = $(this).parents(':eq(5)').find(".main-nav__item").attr("href");
        $("#navigation").html("");
        var breadLink0 = "<li class='flex items-center'><a class='breadcrumbs-list__link' href='{{ routes.root_url }}'>{{ home_title | escape }}</a></li>";
        $("#navigation").append(breadLink0);
        var breadLink1 = "<li class='flex items-center parent-link'><a class='breadcrumbs-list__link' href=\'"+crnt_link+"\'>"+crnt_title+"</a></li>";
        $("#navigation").append(breadLink1);
        var breadLink2 = "<li class='flex items-center collection-link link-end'>{{ collection.title }}</li>";
        $("#navigation").append(breadLink2);
      }
    });
    }
    if(loc == 2){
        $(".link_child").each(function(){
        var linkURL = $(this).attr("href");
        if(currLoc.indexOf(linkURL) > -1){
          var crnt_title = $(this).parents(':eq(5)').find(".main-nav__item").attr("crnt_title");
          var crnt_link = $(this).parents(':eq(5)').find(".main-nav__item").attr("href");
          $("#navigation").html("");
          var breadLink0 = "<li class='flex items-center'><a class='breadcrumbs-list__link' href='{{ routes.root_url }}'>{{ home_title | escape }}</a></li>";
          $("#navigation").append(breadLink0);
          var breadLink1 = "<li class='flex items-center parent-link'><a class='breadcrumbs-list__link' href=\'"+crnt_link+"\'>"+crnt_title+"</a></li>";
          $("#navigation").append(breadLink1);
          var breadLink2 = "<li class='flex items-center collection-link'><a class='breadcrumbs-list__link' href='{{ collection.url }}'>{{ collection.title }}</a></li>";
          $("#navigation").append(breadLink2);
          var breadLink3 = "<li class='flex items-center collection-link-end link-end'>"+childTitle+"</li>";
          $("#navigation").append(breadLink3);
        }
      });
    }
  }
$(document).ready(function(){
  $('.support-section .tab-list-div ul a').click(function(e){
var opentab=$(this).attr('opentab')
  $('.support-section .tab-list-div ul a').removeClass('active')
    $(this).addClass('active');
    $('.tab-content-div .tab ').hide()
    $('.'+opentab).show()

  })
  $('.drop_sublink').click(function(e){
    e.preventDefault();
    $(this).parent().trigger("click");
  });
  $('.drop_subcollection').click(function(e){
    e.preventDefault();
    var ids = $(this).attr('id');
    $('.drop_subcollection').removeClass('active')
    $(this).addClass('active')
    $('.subcollection_listing').hide();
    $('.subcollection_listing[data-pid="'+ids+'"]').show();
    setTimeout(function(){
         $('html, body').animate({
            scrollTop: $('.subcollection_listing[data-pid="'+ids+'"]').offset().top - 150
        }, 200);
    },200);
  });
$('body.product .product .product-info label.opt-label.opt-label--btn.btn.relative.text-center').mouseenter(function(){

  var gtv=$(this).find('span').text();
var gt=$('.product .product-info .product-info__title h1.product-title.h5').text();
    var bews=gt +' - '+gtv
  
  $('span.backorder__product').text(bews)
})

  
//   if($('body').hasClass('product')){
//     const myInterval = setInterval(checkrevs, 100);

// function myTimer() {
//   const date = new Date();
//   document.getElementById("demo").innerHTML = date.toLocaleTimeString();
// }

// function myStopFunction() {
//   clearInterval(myInterval);
// }
//     function checkrevs(){
//       console.log('runs')
//       if($('div#revy-bundles-wrapper').length){
//         $('.get_off').show()
//       }else{
//         $('.get_off').hide() 
//       }
//     }
    
//     setTimeout(function(){
//       myStopFunction();
//     },4000)
//   }
  $('button.btn.btn--primary.w-full.js-quick-add').click(function(e){
    e.preventDefault();
    
  })
  $('details.disclosure.disclosure--row[more=showmore] .disclosure__panel.has-motion .disclosure__content').click(function(){
    jQuery('body').addClass('show-content'); 
$('details.disclosure.disclosure--row[more=showmore]').removeAttr('more')
  })
  $(".qty-input__input").change(function(){
    var qty = $(this).val();
    checkWeightOfVariant(qty);
    checkShippingOfVariant(qty);
  });

  $("#order_cancellation").click(function(){
      window.location.href="/pages/order-cancellation-policy";
    });
    $("#return_policy").click(function(){
      window.location.href="/pages/return-policy";

    });
  
  
  var cartNote = $.trim($("#cart-note").val());
  if(cartNote.length == 0){
    $("#save_btn").hide();
  }
  $("#cart-note").keydown(function(e) {
    $("#save_btn").show();
  });
 /* $("#cart-note").change(function(){
    var cartNote = $.trim($("#cart-note").val());
  if(cartNote.length == 0){
    $("#save_btn").hide();
  }
  });*/
  var save_btn = $('#save_btn');
  save_btn.click(function(){
    $('#save_btn').text("Saving....");
      var cartNote = $.trim($("#cart-note").val());
      if(cartNote.length >= 0){
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };
       this.fetchRequestOpts.body = JSON.stringify({ note: cartNote });
       fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
        $('#save_btn').text("Added Note to Order!");
        changeText("save_btn", "Added Note to Order!", "SAVE"); 
        if(cartNote.length == 0){
          $('#save_btn').hide();
        }
      }
  });
});
function changeText(button, text, textToChangeBackTo) {
  buttonId = document.getElementById(button);
  buttonId.textContent = text;
  setTimeout(function() { back(buttonId, textToChangeBackTo); }, 2000);
  function back(button, textToChangeBackTo){ button.textContent = textToChangeBackTo; }
}
jQuery(document).ready(function(){
    jQuery('body.search').addClass('collection'); 
  $(".open-support").click(function(){
    $("#reamaze-widget").trigger("click");
  });
    
 });
if($('body.product .product-info__add-to-cart.flex button.btn.btn--primary.w-full i').length){}else{
  

$('body.product .product-info__add-to-cart.flex button.btn.btn--primary.w-full').prepend('<i class="pr-2 fas fa-shopping-bag"></i>')
}
$("body.index .section.top_slr .js-quick-add .quick-add-btn-text").text("Add to Cart");

setTimeout(function () {
  if($('body.product .product-info__add-to-cart.flex button.btn.btn--primary.w-full i').length){}else{
  

$('body.product .product-info__add-to-cart.flex button.btn.btn--primary.w-full').prepend('<i class="pr-2 fas fa-shopping-bag"></i>')
}
 $("body.index .section.top_slr .js-quick-add .quick-add-btn-text").text("Add to Cart");},2000)




if($('.item-main-div').length){
  var autoplay=$('.brand-logo-custom-div').attr('auotplay');
  var limit=$('.brand-logo-custom-div').attr('limit');
  var timelmt=limit+'000';
  

}
if($('main#main-content').length){
  

        var distance = $("main#main-content").offset().top,
    $window = $(window);

$window.scroll(function() {
    if ( $window.scrollTop() >= distance ) {
        $('body').addClass('active_scroll')
        }else{
      $('body').removeClass('active_scroll')
    }
});

}
if($('ul.media-thumbs.relative.flex').length){
 setTimeout(function(){
   // console.log('test')
  $('.ul.media-thumbs.relative.flex li:first-child button').trigger('click')
   // $('.ul.media-thumbs.relative.flex li:first-child button')[0].click()
 },4000)
}
      

function checkWeightOfVariant(qty){
  var productWeight = $("#product-weight").html();
  if(productWeight){
     var weightLimit = $("#weight_limit").val();
  var ret = productWeight.split(" lb");
  var productWeight = parseFloat(ret[0]);
    var finalWeight = productWeight * qty;
    if(finalWeight >= weightLimit){
      if($("#weight-msg").hasClass("hidden")){
        $("#weight-msg").removeClass("hidden");
      }
    }else{
         $("#weight-msg").addClass("hidden");
      }
  }
}

function checkShippingOfVariant(qty){
  var productShipping = $("#shipping-msg").html();
  if(productShipping){
    var cPrice = $("#price__default .price__current").html();
    var currentPrice1 = cPrice.replace(/[^\d\.]/g, '');
    var currentPrice = parseFloat(currentPrice1) * qty;
    var shippingLimit = parseFloat($("#shipping_limit").val());
     if(currentPrice >= shippingLimit){
       if($("#shipping-msg").hasClass("hidden")){
         $("#shipping-msg").removeClass("hidden");
       }
     }else{
       $("#shipping-msg").addClass("hidden");
     }
  }
}

function sniptoffer(){
  if($('.product-details .revy-bundle-action').hasClass('added_snipt')){}else{
  $('.product-details .revy-bundle-action').addClass('added_snipt');
$('<div class="get_off"></div>').insertBefore('.product-details div#revy-bundles-wrapper')
     var pris=$('div#price span.current-price.theme-money').text().replace("$", "");
  
   $('.get_off').append('<div class="row_offer"><div class="qty_buy">Buy 1 </div><div class="ec_prc">$'+pris+' ea </div></div>')
 
  $('.product-details .revy-bundle-action button').each(function(){
  var gtmn=$(this).find('span.revy-bundle-button-line.first span.revy-bundle-text-variable').text();
  var gtp=$(this).find('span.revy-bundle-button-line.second span.revy-bundle-text-variable').text().replace("%", "");
  
   
    var nepric=pris*gtp/100
    var iys=pris - nepric
     
 
    $('.get_off').append('<div class="row_offer"><div class="qty_buy">Buy '+gtmn+'	</div><div class="ec_prc">$'+iys.toFixed(2)+' ea </div></div>')
  })
  }
}
// $(window).on('load', function() {
//    sniptoffer();
//   setTimeout(function(){
//     sniptoffer()
//   },2000)
// })


jQuery(document).ready(function(){
  $('#validate_account_form').click(function(e){
    e.preventDefault();
    const captchaValues = window.leminCroppedCaptcha
    .getCaptcha()
    .getCaptchaValue();
    const isCaptchaValid = captchaValues.answer && captchaValues.challenge_id;
    if (isCaptchaValid) {  
      var first_name = document.getElementById("register-first_name");
      if(first_name.value.length){
        var password = document.getElementById("register-password")
            , confirm_password = document.getElementById("password-confirm");
        if(password.value != confirm_password.value) {
          jQuery("#captcha_error").html("Passwords Don't Match"); 
        }else{
           jQuery("#captcha_error").html(''); 
          jQuery("#create_customer").submit();
        } 
      }else{
        jQuery("#captcha_error").html("First name is required"); 
      }                                         
      
     
    }else{
      jQuery("#captcha_error").html('Invalid Captcha!');      
    }
     
  });

  $('#register-form-btn').click(function(e){
    e.preventDefault();

    var password = document.getElementById("register-password")
        , confirm_password = document.getElementById("confirm-password");
    if(password.value != confirm_password.value) {
      jQuery("#form_error").html("Passwords Don't Match"); 
    }else{
       jQuery("#form_error").html(''); 
      jQuery("#create_customer").submit();
    } 
      
     
  });
   
/**/
});